var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item",on:{"click":_vm.selectFAQ}},[_c('div',{staticClass:"question"},[_vm._v(" "+_vm._s(_vm.faq.question)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }